<template>

</template>
<script>
import { setStorage, getStorage, getUrl, setUrl } from "@/utils/wxuser";
import { isWeChat, scriptLoad, getQueryString,initGcTrack,isWeCom } from "@/utils/utils";
import api from "@/utils/api";
import { baseUrl } from "@/utils/baseUrl";
import { jAlert3, jAlert5 } from "@/base/jAlert/jAlert";
import { miniProgram } from "@/utils/miniProgram";
var config = {};
export default {
  data() {
    return {
      code: getQueryString('code') || "",
      debugOpenId: this.$route.query.debugOpenId || "",
      isWeCom:isWeCom(),
      redirect_url:getQueryString("redirect_url") || this.$route.query.redirect_url || "",
    };
  },
  created() {
    window.history.pushState(null, null);
    window.addEventListener("popstate", this.popstate, false);
  },
  destroyed: function () {
    window.removeEventListener("popstate", this.popstate, false);
  },

  methods: {
    async popstate() {
      var isMiniProgram = await miniProgram.isMiniProgram();
      console.log("监听返回");
      if (isMiniProgram) {
        console.log("监听返回小程序");
        miniProgram.navigateBack({
          delta: 1,
        });
      } else {
        console.log("监听返回H5");
        wx.closeWindow();
      }
    },
    authUrl() {
      /*api.authUrl({
        appid:config.appid,
        componentAppid:config.componentAppid,
        url:window.location.href,
      }).then(res=>{
        if(res.result == 1){
          console.log(res.retVal)
          //window.location.href = res.retVal;
        }
        console.log(res)
      })*/
      let scope = "snsapi_base";
      if(sessionStorage.getItem("scope")){
        scope = sessionStorage.getItem("scope");
      }
      // if (window.__wxjs_environment === "miniprogram") {
      //   scope = "snsapi_base";
      // }
      let url = window.location.href;
      if(this.isWeCom){
        let redirect_url = `${window.location.origin}${baseUrl}#${getUrl() ? getUrl() : "/"}`;
        url = `${url}?redirect_url=${encodeURIComponent(redirect_url)}`
      }
      url = encodeURIComponent(url);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=apiauthorize&component_appid=${config.componentAppid}#wechat_redirect`
    },
    login() {
      api.oauthForMember({
        appid: config.appid,
        componentAppid: config.componentAppid,
        code: this.code,
        hotelGroupCode: config.hotelGroupCode,
        hotelGroupId: config.hotelGroupId,
        hotelCode: config.hotelCode
      }).then(res => {
        if (res.result == 1) {
          let wxuser = res.retVal.wxUser;
          let user = res.retVal.user;
          setStorage('wxuser', wxuser);
          initGcTrack();
          if (user && user.memberId) {
            setStorage('user', user);
          } else {
            setStorage('user', "");
          }
          let path = getUrl();
          console.log(`${window.location.origin}${baseUrl}#${path}`)
          if (this.redirect_url) {
            window.location.href = decodeURIComponent(
              this.$route.query.redirect_url
            );
          }else{
            window.location.href = `${window.location.origin}${baseUrl}#${path}`;
          }
          //window.location.href = `${baseUrl}${path}`
          //this.$router.push(path)
        } else {
          jAlert3(res.msg)
        }
        console.log(res)
      })
    },
    userInfo() {
      api.getWxUser({
        hotelCode: config.hotelCode,
        hotelGroupCode: config.hotelGroupCode,
        hotelGroupId: config.hotelGroupId,
        openid: this.debugOpenId,
        appid: config.appid,
        componentAppid: config.componentAppid
      }).then(res => {
        if (res.result == 1) {
          res.retVal.nickName = res.retVal.nickname;
          setStorage("wxuser", res.retVal);
          this.memberLoginOpen();
        } else {
          jAlert3(res.msg)
        }
      })
    },

    memberLoginOpen() {
      api.memberLoginOpen({
        hotelCode: config.hotelCode,
        hotelGroupCode: config.hotelGroupCode,
        hotelGroupId: config.hotelGroupId,
        openid: this.debugOpenId,
        appid: config.appid,
        componentAppid: config.componentAppid
      }).then(data => {
        if (data.result == 1) {
          setStorage("user", data.retVal);
          window.location.href = `${window.location.origin}${baseUrl}#/index?debugMode=T`;
        } else {
          jAlert3('当前debugOpenid无效');
        }
      })
    }
  },
  mounted() {
    config = getStorage("config");
    console.log(this.code)
    // 检测会员有没有登录
    // debugOpenId 自动登录
    console.log(this.debugOpenId);
    if (this.debugOpenId) {
      console.log("debugOpenId进入3")
      this.userInfo();
      return false;
    }
    if (isWeChat()) {
      if (!this.code) {
        console.log('去授权')
        this.authUrl();
      } else {
        document.title = '正在授权中...'
        console.log('去登陆')
        this.login()
      }
    } else {
      console.log('不是微信')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/author/author.vue